export interface BrandSemanticTokens {
  buttonPrimaryGradient: string;
  buttonPrimaryHoverGradient: string;
  buttonPrimaryText: string;
  buttonSecondaryBorder: string;
  buttonSecondaryText: string;
  tabActiveText: string;
  tabInactiveText: string;
  tabIndicator: string;
  toggleActiveBg: string;
  toggleActiveBorder: string;
  toggleActiveText: string;
  filterActiveBg: string;
  filterActiveHoverBg: string;
  filterActiveText: string;
  filterInactiveBg: string;
  filterInactiveText: string;
  filterInactiveBorder: string;
  filterInactiveHoverBg: string;
  navActiveGradient: string;
  navActiveText: string;
  navInactiveText: string;
  linkColor: string;
  focusBorder: string;
  accentColor: string;
  accentLightBg: string;
  accentBorder: string;
  accentShadow: string;
  accentShadowSoft: string;
  highlightText: string;
  chipDefaultGradient: string;
  chipDefaultText: string;
  chipInactiveBg: string;
  chipSelectedBorder: string;
  chipSelectedBg: string;
  cardHighlightBorder: string;
  cardHighlightBg: string;
  decorativeGradient: string;
  progressGradient: string;
}

/** Maps BrandSemanticTokens keys → CSS custom property names in public/themes/{brand}.css */
export const BRAND_TOKEN_CSS_VAR: Record<keyof BrandSemanticTokens, string> = {
  buttonPrimaryGradient: '--brand-button-primary-gradient',
  buttonPrimaryHoverGradient: '--brand-button-primary-hover-gradient',
  buttonPrimaryText: '--brand-button-primary-text',
  buttonSecondaryBorder: '--brand-button-secondary-border',
  buttonSecondaryText: '--brand-button-secondary-text',
  tabActiveText: '--brand-tab-active-text',
  tabInactiveText: '--brand-tab-inactive-text',
  tabIndicator: '--brand-tab-indicator',
  toggleActiveBg: '--brand-toggle-active-bg',
  toggleActiveBorder: '--brand-toggle-active-border',
  toggleActiveText: '--brand-toggle-active-text',
  filterActiveBg: '--brand-filter-active-bg',
  filterActiveHoverBg: '--brand-filter-active-hover-bg',
  filterActiveText: '--brand-filter-active-text',
  filterInactiveBg: '--brand-filter-inactive-bg',
  filterInactiveText: '--brand-filter-inactive-text',
  filterInactiveBorder: '--brand-filter-inactive-border',
  filterInactiveHoverBg: '--brand-filter-inactive-hover-bg',
  navActiveGradient: '--brand-nav-active-gradient',
  navActiveText: '--brand-nav-active-text',
  navInactiveText: '--brand-nav-inactive-text',
  linkColor: '--brand-link-color',
  focusBorder: '--brand-focus-border',
  accentColor: '--brand-accent-color',
  accentLightBg: '--brand-accent-light-bg',
  accentBorder: '--brand-accent-border',
  accentShadow: '--brand-accent-shadow',
  accentShadowSoft: '--brand-accent-shadow-soft',
  highlightText: '--brand-highlight-text',
  chipDefaultGradient: '--brand-chip-default-gradient',
  chipDefaultText: '--brand-chip-default-text',
  chipInactiveBg: '--brand-chip-inactive-bg',
  chipSelectedBorder: '--brand-chip-selected-border',
  chipSelectedBg: '--brand-chip-selected-bg',
  cardHighlightBorder: '--brand-card-highlight-border',
  cardHighlightBg: '--brand-card-highlight-bg',
  decorativeGradient: '--brand-decorative-gradient',
  progressGradient: '--brand-progress-gradient',
};

const createBrandTokensFromCss = (): BrandSemanticTokens => {
  const entries = Object.entries(BRAND_TOKEN_CSS_VAR) as [
    keyof BrandSemanticTokens,
    string,
  ][];

  return entries.reduce(
    (acc, [key, cssVar]) => {
      acc[key] = `var(${cssVar})`;
      return acc;
    },
    {} as BrandSemanticTokens,
  );
};

/**
 * Brand tokens read from public/themes/{brand}.css only.
 * Do not add color literals here — edit student.css / hale.css instead.
 */
export const cssBrandTokens: BrandSemanticTokens = createBrandTokensFromCss();
